import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxCsvParser, NgxCSVParserError } from 'ngx-csv-parser';
import { ConfigurationConstants, NavaidTypes } from 'src/app/models/EnumTypes';
import { ImportFormat } from 'src/app/models/importFormat';
import { NavaidModel, NavAidsCSVContent, NavAidsCsvModel } from 'src/app/models/navaid';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { NavaidControlService } from 'src/app/services/navaid-control.service';
import { NavaidsService } from 'src/app/services/navaids.service';
import { UtilsService } from 'src/app/services/utils.service';


@Component({
  selector: 'app-navaids-csv',
  templateUrl: './navaids-csv.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class NavaidsCsvComponent implements OnInit {

  navaidController: NavaidsService;

  importFormat: ImportFormat = ImportFormat.CSV_FORMAT;

  public navAidsImportCsvModel = new NavAidsCsvModel();

  constructor(private bsModalRef: BsModalRef,
    private modalService: ModalControlService,
    private ngxCsvParser: NgxCsvParser,
    public navaidsService: NavaidControlService,
    navaidController: NavaidsService,
    public utilsService: UtilsService
  ) {
    this.navAidsImportCsvModel = new NavAidsCsvModel();
    this.navaidController = navaidController;
  }

  ngOnInit(): void {
    this.navAidsImportCsvModel.fillTable();
  }

  handleCheckChanged(event, required) {
    if (required) {
      event.preventDefault();
    }
  }


  cancelImport(): void {
    this.bsModalRef.hide();
  }
  saveFile(event: any): void {
    this.navAidsImportCsvModel.file = event.target.files[0];
  }
  startImport(): void {
    this.navAidsImportCsvModel.saveTableConfig();

    if (this.navAidsImportCsvModel.file == null) {
      this.modalService.showMesssageModal("Error", "You have to choose a file before importing it.");
      return;
    }

    if (!this.ngxCsvParser.isCSVFile(this.navAidsImportCsvModel.file)) {
      this.modalService.showMesssageModal("Error", 'The inserted file has an invalid extension. Insert a "csv" file.');
      return;
    }

    if (this.navAidsImportCsvModel.decimalSeparator == this.navAidsImportCsvModel.fieldSeparator) {
      this.modalService.showMesssageModal("Error", 'Please define a different field and decimal separator.');
      return;
    }

    this.ngxCsvParser
      .parse(this.navAidsImportCsvModel.file, { header: false, delimiter: this.navAidsImportCsvModel.fieldSeparator })
      .subscribe((result: Array<any>) => {

        for (let i: number = this.navAidsImportCsvModel.dataStartingLine - 1; i < result.length; i++) {
          if (result[i][result[i].length - 1] === "") { // in cases where the lines in the file end with the separator
            result[i].pop();
          }
          if (result[i].length == 88 || result[i].length == 82 || result[i].length == 81) {
            // The system was able to parse successfully the CSV file.
            const navaidToImport = NavAidsCSVContent.map(result[i], this.navAidsImportCsvModel.table, this.utilsService);
            this.navAidsImportCsvModel.fileContent.push(navaidToImport);
          } else {
            // The system was not able to parse successfully the CSV file.
            this.modalService.showMesssageModal("Import NavAids", "Error encountered in line " + (i + 1) + ".");
            return;
          }

          //this.navAidsImportCsvModel.fileContent.push(this.navaidController.getNavaidPayload(navaidToImport));
        }

        const errors: string[] = this.validateContent(this.navAidsImportCsvModel.fileContent);

        if (errors.length != 0) {
          this.modalService.showMultipleMesssagesModal("Error Importing", errors);
          return;
        }

        const navaidsUnified = this.navaidsService.orderCSVNavAidList(this.navAidsImportCsvModel.fileContent);

        let navAidsPayload: NavaidModel[] = new Array<NavaidModel>();

        navaidsUnified.forEach(navaid => {
          let navaidModel: NavaidModel = this.navaidController.getNavaidPayload(navaid);
          navaidModel.userdefined = this.navAidsImportCsvModel.fileDataSource == "Published" ? false : true;
          navaidModel.isItu = this.navAidsImportCsvModel.countryCoteType == "ITU" ? true : false;
          navAidsPayload.push(navaidModel);

        });

        this.navaidsService.createNavAidFromCSV(navAidsPayload);

      }, (error: NgxCSVParserError) => {
        this.modalService.showMesssageModal("Error", "Unable to extract information in CSV.");
      },
        () => {
          this.bsModalRef.hide();
        });
  }

  validateContent(fileContent: NavaidModel[]): string[] {
    let errors: string[] = [];
    let currentIdentifier: string;
    let errorMessage: string;
    for (let index = 0; index < fileContent.length; index++) {
      const navaid = fileContent[index];
      if (navaid.isSectOrScreeningOrFileLine) {
        continue;
      }
      if (!this.stringNullOrEmpty(navaid.navaidid) && !this.stringNullOrEmpty(navaid.name)) {
        currentIdentifier = navaid.navaidid + "/" + navaid.name;
      } else {
        if (this.stringNullOrEmpty(navaid.navaidid) && this.stringNullOrEmpty(navaid.name)) {
          currentIdentifier = "NavAid";
        } else {
          if (this.stringNullOrEmpty(navaid.navaidid)) {
            currentIdentifier = navaid.name;
          } else {
            currentIdentifier = navaid.navaidid;
          }
        }
      }

      for (let [key, value] of Object.entries(navaid)) {
        switch (key) {
          case "navaidid":
            if (this.stringNullOrEmpty(value)) {
              errorMessage = "Property navAidId cannot be null or empty";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            }
            break;
          case "_latitude":
            if (Number.isNaN(value)) {
              errorMessage = "Property Latitude cannot be null or empty";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            } else if (value == NavAidsCSVContent.ERROR_PARSING_NUMBER || !this.isValidLat(value)) {
              errorMessage = "Property Latitude is not a valid number";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            }
            break;
          case "_longitude":
            if (Number.isNaN(value)) {
              errorMessage = "Property Longitude cannot be null or empty";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            } else if (value == NavAidsCSVContent.ERROR_PARSING_NUMBER || !this.isValidLon(value)) {
              errorMessage = "Property Longitude is not a valid number";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            }
            break;
          case "icaocc":
            if (this.stringNullOrEmpty(value)) {
              errorMessage = "Property Icaocc cannot be null or empty";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            }
            break;
          case "navaidtype":
            if (this.stringNullOrEmpty(value)) {
              errorMessage = "Property Type cannot be null or empty";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            } else if (!this.isValidNavaidType(value)) {
              errorMessage = `Property Type: ${value} is not allowed`;
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            }
            break;
          case "_antheight":
            if (Number.isNaN(value)) {
              errorMessage = "Property Antheight cannot be null or empty";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            } else if (value == NavAidsCSVContent.ERROR_PARSING_NUMBER || !this.isValidFloat(value)) {
              errorMessage = "Property Antheight is not a valid number";
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            }
            break;
          default:
            if (value == NavAidsCSVContent.ERROR_PARSING_NUMBER) {
              errorMessage = `Property ${key} is not a valid number`;
              errors.push(this.buildErrorMessage(currentIdentifier, errorMessage, index));
            }

        }

      }
    }
    return errors;
  }

  private buildErrorMessage(identifier: string, errorMessage: string, index: number): string {
    return `Navaid: ${identifier} - ${errorMessage}. Line ${(index + this.navAidsImportCsvModel.dataStartingLine)}.\n`;
  }

  private isValidNavaidId(navaidId: string): boolean {
    if (navaidId.length >= ConfigurationConstants.COORDINATE_POINT_ID_LENGTH_MIN
      && navaidId.length <= ConfigurationConstants.COORDINATE_POINT_ID_LENGTH_MAX) {
      return true;
    } else {
      return false;
    }
  }

  private stringNullOrEmpty(string: string): boolean {
    if (string) {
      return false;
    } else {
      return true;
    }
  }

  private isValidFloat(float: string): boolean {
    try {
      Number.parseFloat(float);
    } catch (e) {
      return false;
    }
    return true;
  }

  private isValidNavaidType(navaidType: string): boolean {
    try {
      let key = Object.keys(NavaidTypes).find(x => NavaidTypes[x] == navaidType);
      if (key == null) {
        return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  }

  private isValidLat(lat: string): boolean {
    try {
      let latDouble: number = Number.parseFloat(lat);
      if (latDouble <= ConfigurationConstants.LATITUDE_MAX && latDouble >= ConfigurationConstants.LATITUDE_MIN) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  private isValidLon(lon: string): boolean {
    try {
      let lonDouble: number = Number.parseFloat(lon);
      if (lonDouble <= ConfigurationConstants.LONGITUDE_MAX && lonDouble >= ConfigurationConstants.LONGITUDE_MIN) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

}
